<template>
<div class="chapter">
<div class="inner_page">
<p class="tit" id="map"><img alt="image" src="images/map.jpg"/></p>
<div class="page-break">
<p class="sp"> </p>
<p class="FMH1"><span class="ePub-B">THE ISKYRNE</span></p>
<p class="MAP">  <span class="ePub-B">1.</span> H<span class="ePub-SC">ERGILSBERG</span></p>
<p class="MAP">  <span class="ePub-B">2.</span> M<span class="ePub-SC">ONASTERY AT </span>H<span class="ePub-SC">ERGILSBERG</span></p>
<p class="MAP">  <span class="ePub-B">3.</span> S<span class="ePub-SC">IGLUFJORDHUR</span></p>
<p class="MAP">  <span class="ePub-B">4.</span> F<span class="ePub-SC">REYASHEALL</span></p>
<p class="MAP">  <span class="ePub-B">5.</span> O<span class="ePub-SC">THINNSAESC</span></p>
<p class="MAP">  <span class="ePub-B">6.</span> N<span class="ePub-SC">ITHOGSFJOLL</span></p>
<p class="MAP">  <span class="ePub-B">7.</span> F<span class="ePub-SC">RANANGFORD &amp; </span>A<span class="ePub-SC">ETTRYNHEIM</span></p>
<p class="MAP">  <span class="ePub-B">8.</span> B<span class="ePub-SC">RAVOLL</span></p>
<p class="MAP">  <span class="ePub-B">9.</span> T<span class="ePub-SC">HORSBAER</span></p>
<p class="MAP"><span class="ePub-B">10.</span> V<span class="ePub-SC">ESTFJORTHR</span></p>
<p class="MAP"><span class="ePub-B">11.</span> A<span class="ePub-SC">RAKENSBERG</span></p>
<p class="MAP"><span class="ePub-B">12.</span> B<span class="ePub-SC">EORNESBEORG</span></p>
<p class="MAP"><span class="ePub-B">13.</span> B<span class="ePub-SC">EONVITHR</span></p>
<p class="MAP"><span class="ePub-B">14.</span> K<span class="ePub-SC">ERLAUGSTROND</span></p>
<p class="MAP"><span class="ePub-B">15.</span> K<span class="ePub-SC">ETILLHILL</span></p>
<p class="MAP"><span class="ePub-B">16.</span> N<span class="ePub-SC">EW </span>N<span class="ePub-SC">IDAVELLIR</span></p>
<p class="MAP"><span class="ePub-B">17.</span> N<span class="ePub-SC">ORTH </span>P<span class="ePub-SC">OLE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// map.vue?089e82b4